const ENABLE_BRAIN_TYPE_ENTRY = false;
const ENABLE_BRAIN_TYPE_EDU_AND_ENTRY = false;
const ENABLE_BRAIN_TYPE_WEB_VR = false;

const PROJECT_STYLE = 'ww';

const DEFAULT_LOCALE = "zh-tw";

const ENABLE_AI_SPEECH = false;

export {
    ENABLE_BRAIN_TYPE_ENTRY,
    ENABLE_BRAIN_TYPE_EDU_AND_ENTRY,
    ENABLE_BRAIN_TYPE_WEB_VR,
    PROJECT_STYLE,
    ENABLE_AI_SPEECH,
    DEFAULT_LOCALE
}